// @ts-nocheck
/* oxlint-disable no-self-assign */

import { AFibEvent, ANNOTATION_TYPE, Pattern, SampleMark } from '@/widgets/ecg-viewer';
import { addSVGs } from '@/shared/lib';
import { fabric } from 'fabric';
import _ from 'lodash';

let EcgView;

(function () {
  EcgView = function (
    canvasChart: any,
    pixelSamples: any,
    config: any,
    displayedChannelsArr: any,
    verticalChannelPlacement: any,
    isStreaming: any,
    getSteamingDataFunc: any,
    onBpmChanged: any,
  ) {
    this.canvasChart = canvasChart;
    this.pixelSamples = pixelSamples;
    this.displayedChannelsArr = displayedChannelsArr;
    this.config = config;
    this.verticalChannelPlacement = verticalChannelPlacement;
    this.isStreaming = isStreaming;
    this.getSteamingDataFunc = getSteamingDataFunc;
    this.onBpmChanged = onBpmChanged;
    this.ctxChart = this.canvasChart.getContext('2d');
    this.ctxChart.lineWidth = isStreaming ? 1.2 : 1.1; // *: For draw
    this.lineWidthExport = 1.2; // *: For export
    this.sampleMarkColor = '#f80000';
    this.patternColor = '#f80000';
    this.sampleMarksArray = [];
    this.patternsArray = [];
    this.afibEventsArray = [];
    this.specifySampleMark = null;
    this.specifyPattern = null;
    this.isDrawingSampleMark = false;
    this.lastPoint = [];
    this.animationFrame = null;
    this.targetFPS = 30;
    this.frameDuration = 1000 / this.targetFPS;
    this.lastFrameTime = 0;
    this.streamingOffsetX = 0;
    this.maxStreamingDrawLength = 2500;
    this.streamingDrawedLength = 0;
    this.drawIndex = 0;
  };

  EcgView.prototype.draw = function (offsetX: any) {
    // *: Clear old chart
    this.canvasChart.clear();

    // *: 3 main lines
    this.drawAllChartLine(offsetX);

    // TODO: Prevent selected mark/pattern when scrolling
    // *: Sample mark lines
    if (!this.specifySampleMark) {
      _.forEach(this.sampleMarksArray, (sampleMark) => {
        (sampleMark as any).drawOneSampleMark(offsetX, 'blue');
      });
    } else {
      this.drawSpecifySampleMark(offsetX);
    }

    // *: Patterns
    if (!this.specifyPattern) {
      _.forEach(this.patternsArray, (pattern) => {
        (pattern as any).drawOnePattern(offsetX);
      });
    } else {
      this.drawSpecifyPattern(offsetX);
    }

    // *: AFib events
    _.forEach(this.afibEventsArray, (afibEvent) => {
      (afibEvent as any).drawOneAFibEvent(offsetX);
    });
  };

  EcgView.prototype.drawEmptyLineStreaming = function () {
    this.ctxChart.beginPath();
    this.ctxChart.strokeStyle = '#000';
    this.ctxChart.moveTo(0, this.verticalChannelPlacement[0]);
    this.ctxChart.lineTo(this.config.width, this.verticalChannelPlacement[0]);
    this.ctxChart.moveTo(0, this.verticalChannelPlacement[1]);
    this.ctxChart.lineTo(this.config.width, this.verticalChannelPlacement[1]);
    this.ctxChart.moveTo(0, this.verticalChannelPlacement[2]);
    this.ctxChart.lineTo(this.config.width, this.verticalChannelPlacement[2]);
    this.ctxChart.stroke();
    this.ctxChart.closePath();
  };

  EcgView.prototype.drawStreaming = function () {
    // this.drawEmptyLineStreaming();

    if (this.animationFrame) {
      cancelAnimationFrame(this.animationFrame);
    }
    this.lastPoint = [];
    this.handleDrawStreaming(this.streamingOffsetX, 0);
  };

  EcgView.prototype.getStreamingData = function (pointPerFrame: any): any {
    const drawPoints: any = [];
    const nextPoint: any = [];
    const steamingData = this.getSteamingDataFunc();
    if (steamingData.length > 0) {
      // const ch1 = steamingData[0].data[1];
      // this.canvasChart.clear();
      // for (let j = 0; j < 2499; j += 1) { // ch 1,2,3
      //   this.ctxChart.beginPath();
      //   this.ctxChart.strokeStyle = '#000';
      //   this.ctxChart.moveTo(ch1[j].x - ch1[0].x, ch1[j].y);
      //   this.ctxChart.lineTo(ch1[j + 1].x - ch1[0].x, ch1[j + 1].y);
      //   this.ctxChart.stroke();
      //   this.ctxChart.closePath();
      // }
      _.forEach(steamingData[0].data, (data, index) => {
        const points = data.slice(0, pointPerFrame);
        nextPoint.push(data[pointPerFrame]);
        // const indexedPoints = points.map(point => ({ x: Math.floor(this.streamingDrawedLength * this.config.indexToPix), y: point.y }));
        /**
         * Plain coordinate pairs derived from the polyline points. Maps each point to a new object carrying only its x and y values.
         *
         * @returns The stripped-down point list.
         */
        const indexedPoints = points.map((point: any) => ({ x: point.x, y: point.y }));
        drawPoints.push(indexedPoints);
        steamingData[0].data[index] = data.slice(pointPerFrame);
        // drawPoints.push(data);
        // steamingData[0].data[index] = [];
      });

      // remove empty data
      if (steamingData.length > 0 && steamingData[0].data[0].length === 0) {
        steamingData.shift();
        if (steamingData.length > 0 && steamingData[0].data[0].length > 0) {
          // update bpm of new section data
          this.onBpmChanged(steamingData[0].bpm);
        }
      }
      return {
        drawPoints: _.zip(...drawPoints),
        nextPoint,
      };
    }
    return {
      drawPoints: [],
      nextPoint: [],
    };
  };

  EcgView.prototype.canDrawStreaming = function (timestamp: any) {
    // function to limit fps
    // assign to 'then' for the first run
    if (this.lastFrameTime === undefined) {
      this.lastFrameTime = timestamp;
    }

    const delta = timestamp - this.lastFrameTime;

    if (delta > this.frameDuration) {
      // update time stuffs

      // Just `then = now` is not enough.
      // Lets say we set fps at 10 which means
      // each frame must take 100ms
      // Now frame executes in 16ms (60fps) so
      // the loop iterates 7 times (16*7 = 112ms) until
      // delta > interval === true
      // Eventually this lowers down the FPS as
      // 112*10 = 1120ms (NOT 1000ms).
      // So we have to get rid of that extra 12ms
      // by subtracting delta (112) % interval (100).
      // Hope that makes sense.

      this.lastFrameTime = timestamp - (delta % this.frameDuration);

      // ... Code for Drawing the Frame ...
      return true;
    }
    return false;
  };

  EcgView.prototype.drawEachPoint = function (drawPoint: any, nextPoint: any): any {
    this.ctxChart.beginPath();
    this.ctxChart.strokeStyle = '#000';
    const tempLastPoint: any = [];
    _.forEach(drawPoint, (point, i) => {
      // const moveToX = _.isEmpty(this.lastPoint) ? 0 : this.lastPoint[i].x;
      // const moveToY = _.isEmpty(this.lastPoint) ? point.y : this.lastPoint[i].y;
      // const lineToX = _.isEmpty(this.lastPoint) ? 0 : point.x;
      // const lineToY = point.y;

      const moveToX = point.x;
      const moveToY = point.y;
      const lineToX = _.isEmpty(nextPoint?.[i]) ? point.x : nextPoint[i].x;
      const lineToY = _.isEmpty(nextPoint?.[i]) ? point.y : nextPoint[i].y;

      this.ctxChart.moveTo(moveToX, moveToY);
      this.ctxChart.lineTo(lineToX, lineToY);
      this.ctxChart.clearRect(moveToX, 0, 40, 300);
      this.streamingOffsetX = lineToX;
      tempLastPoint.push({ x: lineToX, y: lineToY });
    });
    this.lastPoint = tempLastPoint;
    this.ctxChart.stroke();
    this.ctxChart.closePath();
  };

  EcgView.prototype.handleDrawStreaming = function (offsetX: any, timestamp: any) {
    if (this.streamingDrawedLength >= this.maxStreamingDrawLength) {
      // end of 10s data
      this.streamingDrawedLength = 0;
      this.lastPoint = [];
      this.streamingOffsetX = 0;
    }
    this.animationFrame = requestAnimationFrame((timestamp) =>
      this.handleDrawStreaming(offsetX, timestamp),
    );

    // limit 60fps
    if (this.canDrawStreaming(timestamp)) {
      // draw 4 point/sec
      const steamingData = this.getSteamingDataFunc();

      if (steamingData.length === 0 || steamingData[0].data[0].length === 0) {
        return;
      }

      if (this.drawIndex + 1 >= steamingData[0].data[0].length) {
        this.drawIndex = 0;
        steamingData.shift();
        if (steamingData.length > 0 && steamingData[0].data[0].length > 0) {
          // update bpm of new section data
          this.onBpmChanged(steamingData[0].bpm);
        }
        // const ch1 = steamingData[0].data[1];
        // this.canvasChart.clear();
        // for (let j = 0; j < 2499; j += 1) { // ch 1,2,3
        //   this.ctxChart.beginPath();
        //   this.ctxChart.strokeStyle = '#000';
        //   this.ctxChart.moveTo(ch1[j].x - ch1[0].x, ch1[j].y);
        //   this.ctxChart.lineTo(ch1[j + 1].x - ch1[0].x, ch1[j + 1].y);
        //   this.ctxChart.stroke();
        //   this.ctxChart.closePath();
        // }
      }

      let points = 8;
      if (steamingData.length > 1) {
        points = 9;
      }
      // const { drawPoints, nextPoint } = this.getStreamingData(points);
      // this.streamingDrawedLength += drawPoints.length;
      // _.forEach(drawPoints, (point, index) => {
      //   this.drawEachPoint(point, drawPoints.length - 1 === index ? nextPoint : drawPoints[index + 1]);
      // });

      const ch1 = steamingData[0]?.data[0];
      const ch2 = steamingData[0]?.data[1];
      const ch3 = steamingData[0]?.data[2];
      this.ctxChart.beginPath();
      this.ctxChart.strokeStyle = '#000';
      for (let j = 0; j < points; j += 1) {
        if (ch1?.[this.drawIndex + 1 + j]?.x) {
          this.ctxChart.moveTo(ch1[this.drawIndex + j].x, ch1[this.drawIndex + j].y);
          this.ctxChart.lineTo(ch1[this.drawIndex + 1 + j].x, ch1[this.drawIndex + 1 + j].y);
          this.ctxChart.clearRect(ch1[this.drawIndex + j].x, 0, 40, 300);
        }
      }
      for (let j = 0; j < points; j += 1) {
        if (ch2?.[this.drawIndex + 1 + j]?.x) {
          this.ctxChart.moveTo(ch2[this.drawIndex + j].x, ch2[this.drawIndex + j].y);
          this.ctxChart.lineTo(ch2[this.drawIndex + 1 + j].x, ch2[this.drawIndex + 1 + j].y);
          this.ctxChart.clearRect(ch2[this.drawIndex + j].x, 0, 40, 300);
        }
      }
      for (let j = 0; j < points; j += 1) {
        if (ch3?.[this.drawIndex + 1 + j]?.x) {
          this.ctxChart.moveTo(ch3[this.drawIndex + j].x, ch3[this.drawIndex + j].y);
          this.ctxChart.lineTo(ch3[this.drawIndex + 1 + j].x, ch3[this.drawIndex + 1 + j].y);
          this.ctxChart.clearRect(ch3[this.drawIndex + j].x, 0, 40, 300);
        }
      }
      this.drawIndex += points;
      this.ctxChart.stroke();
      this.ctxChart.closePath();
    }
  };

  EcgView.prototype.drawAllChartLine = function (offsetX: any) {
    const { sampleLength, sampleRange } = this.config;
    const start = offsetX;
    const end =
      sampleRange - 1 + offsetX <= sampleLength ? sampleRange - 1 + offsetX : sampleLength - 1;
    this.ctxChart.beginPath();
    this.ctxChart.strokeStyle = '#000';
    _.forEach(this.pixelSamples, (displayedSamples) => {
      for (let j = start; j < end; j += 1) {
        this.ctxChart.moveTo(
          displayedSamples[j].x - displayedSamples[start].x,
          displayedSamples[j].y,
        );
        this.ctxChart.lineTo(
          displayedSamples[j + 1].x - displayedSamples[start].x,
          displayedSamples[j + 1].y,
        );
      }
    });
    this.ctxChart.stroke();
    this.ctxChart.closePath();
  };

  EcgView.prototype.drawSampleMark = function (offsetX: any, sampleMark: any) {
    // TODO: Handle duplicate line
    // const startSample = offsetX;
    // const endSample = startSample + this.config.sampleRange;

    const sampleMarkLine = new SampleMark.SampleMark(
      this.canvasChart,
      this.verticalChannelPlacement,
      this.config,
      this.displayedChannelsArr,
      this.pixelSamples,
      sampleMark,
    );
    this.sampleMarksArray.push(sampleMarkLine);
    (sampleMarkLine as any).drawOneSampleMark(offsetX, this.sampleMarkColor);
    this.specifySampleMark = sampleMarkLine;
    // this.isDrawnSelectedSampleMark = true;
  };

  EcgView.prototype.drawSpecifySampleMark = function (offsetX: any) {
    _.forEach(this.sampleMarksArray, (sampleMark) => {
      if (sampleMark !== this.specifySampleMark) {
        // draw other sample mark
        (sampleMark as any).drawOneSampleMark(offsetX, 'blue');
      }
    });

    // *: Draw specify sample mark
    this.specifySampleMark.drawOneSampleMark(offsetX, this.sampleMarkColor);
  };

  EcgView.prototype.selectMark = function (
    clickedOffsetX: any,
    points: any,
    clickedChannelIndex: any,
  ) {
    const realChannelIndex = this.displayedChannelsArr[clickedChannelIndex];
    /**
     * Sample marks placed on the channel that was clicked. Filters the stored sample-mark array by a channel index equal to the resolved real channel index.
     *
     * @returns Sample marks on the clicked channel.
     */
    const clickedSampleMarksArray = _.filter(
      this.sampleMarksArray,
      (x) => x.channelIndex === realChannelIndex,
    );
    const filteredSampleMark = [];

    // *: Find selected mark
    if (clickedSampleMarksArray.length > 0) {
      for (let i = 0; i < clickedSampleMarksArray.length; i += 1) {
        const { startSample, endSample } = clickedSampleMarksArray[i];
        if (
          clickedOffsetX >= startSample - 10 &&
          clickedOffsetX <= startSample + 10 &&
          points.y >= clickedSampleMarksArray[i].startY &&
          points.y <= clickedSampleMarksArray[i].endY
        ) {
          // click startY
          // if (!_.includes(filteredSampleMark, clickedSampleMarksArray[i])) {
          filteredSampleMark.push(clickedSampleMarksArray[i]);
          // }
        } else if (
          clickedOffsetX >= endSample - 10 &&
          clickedOffsetX <= endSample + 10 &&
          points.y >= clickedSampleMarksArray[i].startY &&
          points.y <= clickedSampleMarksArray[i].endY
        ) {
          // click endY
          // if (!_.includes(filteredSampleMark, clickedSampleMarksArray[i])) {
          filteredSampleMark.push(clickedSampleMarksArray[i]);
          // }
        } else if (clickedOffsetX >= startSample && clickedOffsetX <= endSample) {
          // click inside
          for (let k = clickedOffsetX - 10; k < clickedOffsetX + 10; k += 1) {
            if (
              points.y >= this.pixelSamples[clickedChannelIndex][k].y - 10 &&
              points.y <= this.pixelSamples[clickedChannelIndex][k].y + 10
            ) {
              // if (!_.includes(filteredSampleMark, clickedSampleMarksArray[i])) {
              filteredSampleMark.push(clickedSampleMarksArray[i]);
              // }
            }
          }
        }
      }
    }

    // *: Set flag
    if (!filteredSampleMark.length) {
      this.specifySampleMark = null;
    } else if (filteredSampleMark[filteredSampleMark.length - 1] !== this.specifySampleMark) {
      this.specifySampleMark = filteredSampleMark[filteredSampleMark.length - 1];
      this.isDrawnSelectedSampleMark = false;
    } else {
      this.specifySampleMark = this.specifySampleMark;
      this.isDrawnSelectedSampleMark = true;
    }
  };

  EcgView.prototype.drawSelectedMark = function (offsetX: any) {
    if (this.specifySampleMark && !this.isDrawnSelectedSampleMark) {
      // *: selected sample mark
      this.isDrawnSelectedSampleMark = true;

      this.canvasChart.clear();

      this.drawAllChartLine(offsetX);

      _.forEach(this.patternsArray, (pattern) => {
        (pattern as any).drawOnePattern(offsetX);
      });

      _.forEach(this.afibEventsArray, (afibEvent) => {
        (afibEvent as any).drawOneAFibEvent(offsetX);
      });

      if (this.specifySampleMark.startSample > this.specifySampleMark.endSample) {
        const tmp = this.specifySampleMark.startSample;
        this.specifySampleMark.startSample = this.specifySampleMark.endSample;
        this.specifySampleMark.endSample = tmp;
      }
      this.drawSpecifySampleMark(offsetX);
    } else if (!this.specifySampleMark && !this.specifyPattern) {
      this.draw(offsetX);
    }
  };

  // EcgView.prototype.editSampleMark = function (offsetX, offsetXVLine) {
  //   if (this.isClickFirstVLine) {
  //     this.specifySampleMark.startSample += offsetXVLine;
  //   } else {
  //     this.specifySampleMark.endSample += offsetXVLine;
  //   }
  //   this.specifySampleMark.firstVLineIndex = this.specifySampleMark.startSample;
  //   this.specifySampleMark.lastVLineIndex = this.specifySampleMark.endSample;
  //   this.specifySampleMark.sampleMarkRange = this.specifySampleMark.endSample - this.specifySampleMark.startSample;

  //   this.draw(offsetX);
  // };

  EcgView.prototype.drawPattern = function (offsetX: any, specifyPattern: any) {
    const pattern = new Pattern.Pattern(
      this.canvasChart,
      this.config,
      this.displayedChannelsArr,
      this.pixelSamples,
      specifyPattern,
    );
    (pattern as any).drawOnePattern(offsetX, this.patternColor);
    this.specifyPattern = pattern;
    this.patternsArray.push(pattern);
  };

  EcgView.prototype.drawSpecifyPattern = function (offsetX: any, color = this.patternColor) {
    _.forEach(this.patternsArray, (pattern) => {
      if (pattern !== this.specifyPattern) {
        // *: Draw other pattern
        (pattern as any).drawOnePattern(offsetX);
      }
    });

    // *: Draw specify pattern
    this.specifyPattern.drawOnePattern(offsetX, color);
  };

  EcgView.prototype.selectPattern = function (
    clickedOffsetX: any,
    points: any,
    clickedChannelIndex: any,
  ) {
    const realChannelIndex = this.displayedChannelsArr[clickedChannelIndex];
    /**
     * Patterns placed on the channel that was clicked. Filters the stored pattern array by a channel index equal to the resolved real channel index.
     *
     * @returns Patterns on the clicked channel.
     */
    const clickedPatternArray = _.filter(
      this.patternsArray,
      (x) => x.channelIndex === realChannelIndex,
    );
    const filteredPattern = [];

    // *: Find selected pattern
    if (clickedPatternArray.length > 0) {
      for (let i = 0; i < clickedPatternArray.length; i += 1) {
        const { startSample, endSample } = clickedPatternArray[i];

        if (clickedOffsetX >= startSample && clickedOffsetX <= endSample) {
          // *: Click inside
          for (let k = clickedOffsetX - 10; k < clickedOffsetX + 10; k += 1) {
            if (
              points.y >= this.pixelSamples[clickedChannelIndex][k].y - 10 &&
              points.y <= this.pixelSamples[clickedChannelIndex][k].y + 10
            ) {
              if (!_.includes(filteredPattern, clickedPatternArray[i])) {
                filteredPattern.push(clickedPatternArray[i]);
              }
            }
          }
        }
      }
    }

    if (!filteredPattern.length) {
      this.specifyPattern = null;
    } else if (filteredPattern[filteredPattern.length - 1] !== this.specifyPattern) {
      this.specifyPattern = filteredPattern[filteredPattern.length - 1];
      this.isDrawnSelectedPattern = false;
    } else {
      this.specifyPattern = this.specifyPattern;
      this.isDrawnSelectedPattern = true;
    }
  };

  EcgView.prototype.drawSelectedPattern = function (offsetX: any) {
    if (this.specifyPattern && !this.isDrawnSelectedPattern) {
      // *: Selected pattern
      this.isDrawnSelectedPattern = true;

      this.canvasChart.clear();

      this.drawAllChartLine(offsetX);

      _.forEach(this.sampleMarksArray, (sampleMark) => {
        (sampleMark as any).drawOneSampleMark(offsetX, 'blue');
      });

      _.forEach(this.afibEventsArray, (afibEvent) => {
        (afibEvent as any).drawOneAFibEvent(offsetX);
      });

      if (this.specifyPattern.startSample > this.specifyPattern.endSample) {
        const tmp = this.specifyPattern.startSample;
        this.specifyPattern.startSample = this.specifyPattern.endSample;
        this.specifyPattern.endSample = tmp;
      }
      this.drawSpecifyPattern(offsetX);
    } else if (!this.specifyPattern && !this.specifySampleMark) {
      this.draw(offsetX);
    }
  };

  EcgView.prototype.changePatternColor = function (color: any, offsetX: any) {
    this.canvasChart.clear();

    this.drawAllChartLine(offsetX);

    _.forEach(this.sampleMarksArray, (sampleMark) => {
      (sampleMark as any).drawOneSampleMark(offsetX, 'blue');
    });

    this.specifyPattern.changeColor(color);
    this.drawSpecifyPattern(offsetX, color);
  };

  EcgView.prototype.deleteMark = function () {
    if (this.specifySampleMark) {
      // *: Delete sample mark
      _.remove(this.sampleMarksArray, (x) => x === this.specifySampleMark);
      this.specifySampleMark = null;
    } else if (this.specifyPattern) {
      // *: Delete pattern
      _.remove(this.patternsArray, (x) => x === this.specifyPattern);
      this.specifyPattern = null;
    }
  };

  EcgView.prototype.update = function (
    pixelSamples: any,
    config: any,
    displayedChannelsArr: any,
    verticalChannelPlacement: any,
  ) {
    this.pixelSamples = pixelSamples;
    this.config = config;
    this.displayedChannelsArr = displayedChannelsArr;
    this.verticalChannelPlacement = verticalChannelPlacement;

    // *: Update sample marks
    _.forEach(this.sampleMarksArray, (sampleMark) => {
      sampleMark.update(
        this.pixelSamples,
        this.config,
        this.displayedChannelsArr,
        this.verticalChannelPlacement,
      );
    });

    // *: Update patterns
    _.forEach(this.patternsArray, (pattern) => {
      pattern.update(
        this.pixelSamples,
        this.config,
        this.displayedChannelsArr,
        this.verticalChannelPlacement,
      );
    });

    // *: Update AFib events
    _.forEach(this.afibEventsArray, (afibEvent) => {
      afibEvent.update(this.pixelSamples, this.config, this.displayedChannelsArr);
    });
  };

  EcgView.prototype.applyAI = function (isAppliedAI: any, offsetX: any, afibEventsArray: any) {
    this.isAppliedAI = isAppliedAI;
    this.afibEventsArray = [];
    if (isAppliedAI) {
      _.forEach(afibEventsArray, (specifyAFibEvent) => {
        const afibEvent = new AFibEvent.AFibEvent(
          this.canvasChart,
          this.config,
          this.displayedChannelsArr,
          this.pixelSamples,
          specifyAFibEvent,
        );
        this.afibEventsArray.push(afibEvent);
      });
    }
    this.draw(offsetX);
  };

  // EcgView.prototype.updateSpecifySampleMark = function () {
  //   const start = this.specifySampleMark.startSample;
  //   const end = this.specifySampleMark.endSample;
  //   this.specifySampleMark.startSample = Math.min(start, end);
  //   this.specifySampleMark.endSample = Math.max(start, end);
  //   this.specifySampleMark.firstVLineIndex = this.specifySampleMark.startSample;
  //   this.specifySampleMark.lastVLineIndex = this.specifySampleMark.endSample;
  //   this.specifySampleMark.sampleMarkRange = this.specifySampleMark.endSample - this.specifySampleMark.startSample;
  //   this.isClickFirstVLine = false;
  //   this.isClickLastVLine = false;
  // };

  EcgView.prototype.updateData = function () {
    this.specifySampleMark = null;
    this.specifyPattern = null;
    this.specifyAFibEvent = null;
    this.sampleMarksArray = [];
    this.patternsArray = [];
    this.afibEventsArray = [];
  };

  EcgView.prototype.drawPolyline = function (points: any, stroke: any, strokeWidth: any) {
    return new fabric.Polyline(points, {
      stroke,
      fill: '',
      strokeWidth,
      strokeLineJoin: 'round',
      strokeLineCap: 'round',
    });
  };

  EcgView.prototype.deSelectPartly = function (annotation: any, resetSelected: any) {
    // *: De-select annotation
    let { selectedObj } = annotation;
    if (resetSelected) {
      if (selectedObj) {
        selectedObj = annotation.selectedObj;
        selectedObj.deselect();
      }
    } else if (selectedObj) {
      selectedObj.select();
    }
  };

  EcgView.prototype.exportPartly = function (
    titleChart: any,
    markers: any,
    annotation: any,
    gridBackGround: any,
    canvasObject: any,
    start: any,
  ) {
    // *: Update partly (to export)
    titleChart.draw(start);
    markers.draw(start);
    annotation.scroll(start, this.displayedChannelsArr);

    let eventPositionAnnotation;
    _.forEach(annotation.annoArr, (anno) => {
      if (anno.type === ANNOTATION_TYPE.BCC) {
        anno.setTextForExport();
      }

      // *: Hide event position when exporting image
      if (anno.type === ANNOTATION_TYPE.EVENT_POSITION) {
        anno.isVisibility(false);
        eventPositionAnnotation = anno;
      }
    });

    // *: Export svg background
    const svgbg = gridBackGround.export();

    // *: Export svg object
    const svgObject = canvasObject.toSVG(
      {
        viewBox: {
          x: 0,
          y: 0,
          width: 945,
          height: 250,
        },
      },
      (e: any) => (e.includes('hidden') ? '' : e),
    );

    // *: Re-show event position after exporting image completely
    if (eventPositionAnnotation) {
      eventPositionAnnotation.isVisibility(true);
    }

    return { svgbg, svgObject };
  };

  EcgView.prototype.exportAll = function (
    titleChart: any,
    markers: any,
    annotation: any,
    gridBackGround: any,
    canvasObject: any,
  ) {
    const { sampleRange, sampleLength } = this.config;

    let isDrawAll = false;
    for (let i = 0; i < this.sampleMarksArray.length; i += 1) {
      if (!_.includes(this.displayedChannelsArr, this.sampleMarksArray[i].channelIndex)) {
        isDrawAll = true;
      } else {
        isDrawAll = false;
        break;
      }
    }

    if (this.sampleMarksArray.length > 0 && !isDrawAll) {
      // *: Have sample marks
      const svgMain = [];

      // *: Filter sample marks are in displayed line to draw
      /**
       * Sample marks belonging to any currently displayed channel. Filters the stored sample-mark array to entries whose channel index appears in the displayed channel list.
       *
       * @returns Sample marks on visible channels.
       */
      const inlineSampleMarkArray = _.filter(this.sampleMarksArray, (x) =>
        _.includes(this.displayedChannelsArr, x.channelIndex),
      );

      for (let j = 0; j < inlineSampleMarkArray.length; j += 1) {
        let { startSample } = inlineSampleMarkArray[j];
        let endSample =
          startSample + sampleRange - 1 < sampleLength
            ? startSample + sampleRange - 1
            : sampleLength - 1;

        if (inlineSampleMarkArray[j].sampleMarkRange <= sampleRange) {
          // *: De-select partly
          this.deSelectPartly(annotation, true);

          // *: Export svg canvas object
          const { svgbg, svgObject } = this.exportPartly(
            titleChart,
            markers,
            annotation,
            gridBackGround,
            canvasObject,
            startSample,
          );

          // *: Export svg canvas chart
          const svg = this.exportSVG(startSample, endSample);

          // *: Create svg main
          svgMain.push(addSVGs([svgbg, svg, svgObject]));

          // *: Undo selected partly
          this.deSelectPartly(annotation, false);
        } else {
          // *: Calculate number of window
          const windowCounter = Math.ceil(inlineSampleMarkArray[j].sampleMarkRange / sampleRange);

          // *: Devide many segments
          for (let l = 0; l < windowCounter; l += 1) {
            this.deSelectPartly(annotation, true);

            const { svgbg, svgObject } = this.exportPartly(
              titleChart,
              markers,
              annotation,
              gridBackGround,
              canvasObject,
              startSample,
            );
            const svg = this.exportSVG(startSample, endSample);
            svgMain.push(addSVGs([svgbg, svg, svgObject]));

            this.deSelectPartly(annotation, false);

            // *: Update start, end
            startSample = endSample + 1;
            endSample =
              startSample + sampleRange - 1 < sampleLength
                ? startSample + sampleRange - 1
                : sampleLength - 1;
          }
        }
      }

      return svgMain;
    }

    const svgMain = [];

    for (let i = 0; i < sampleLength; i += sampleRange) {
      const start = i;
      const end =
        start + sampleRange - 1 <= sampleLength - 1 ? start + sampleRange - 1 : sampleLength - 1;

      this.deSelectPartly(annotation, true);

      const { svgbg, svgObject } = this.exportPartly(
        titleChart,
        markers,
        annotation,
        gridBackGround,
        canvasObject,
        start,
      );
      const svg = this.exportSVG(start, end);

      svgMain.push(addSVGs([svgbg, svg, svgObject]));

      this.deSelectPartly(annotation, false);

      // start = end;
      // end = start + sampleRange;
    }

    return svgMain;
  };

  EcgView.prototype.exportSVG = function (startSample: any, endSample: any): any {
    // *: Create chart array points
    const arrayLinePointsBlack = [];
    const arrayLinePointsBlue = [];
    const arrayPatternPoints = [];
    const arrayAFibEventPoints = [];
    for (let i = 0; i < this.displayedChannelsArr.length; i += 1) {
      /**
       * Sample marks belonging to the channel drawn at the current row index. Filters the stored sample-mark array by a channel index equal to the displayed channel at position i.
       *
       * @returns Sample marks for that channel.
       */
      const inlineSampleMarkArray = _.filter(
        this.sampleMarksArray,
        (x) => x.channelIndex === this.displayedChannelsArr[i],
      );
      if (inlineSampleMarkArray.length > 0) {
        let startEndArray = [];
        for (let j = 0; j < inlineSampleMarkArray.length; j += 1) {
          startEndArray.push({
            start: inlineSampleMarkArray[j].startSample,
            end: inlineSampleMarkArray[j].endSample,
          });
          const arraySampleMarkLine = [];
          for (let k = startSample; k <= endSample; k += 1) {
            if (
              k >= inlineSampleMarkArray[j].startSample &&
              k <= inlineSampleMarkArray[j].endSample
            ) {
              if (
                k === inlineSampleMarkArray[j].startSample || // *: First vertical line
                k === inlineSampleMarkArray[j].endSample
              ) {
                // *: Last vertical line
                const arrayVLine = [];
                for (
                  let l = inlineSampleMarkArray[j].startY;
                  l <= inlineSampleMarkArray[j].endY;
                  l += 1
                ) {
                  const x = this.pixelSamples[i][k].x - this.pixelSamples[i][startSample].x;
                  arrayVLine.push(
                    new fabric.Point(
                      x === this.config.width ? x - this.ctxChart.lineWidth / 2 : x,
                      l,
                    ),
                  );
                }
                arrayLinePointsBlue.push({ points: arrayVLine, strokeStyle: 'blue' });
              } else {
                // *: Sample mark line
                arraySampleMarkLine.push(
                  new fabric.Point(
                    this.pixelSamples[i][k].x - this.pixelSamples[i][startSample].x,
                    this.pixelSamples[i][k].y,
                  ),
                );
              }
            }
          }
          if (arraySampleMarkLine.length > 0) {
            arrayLinePointsBlue.push({ points: arraySampleMarkLine, strokeStyle: 'blue' });
          }
        }

        /**
         * Patterns belonging to the channel drawn at the current row index. Filters the stored pattern array by a channel index equal to the displayed channel at position i.
         *
         * @returns Patterns for that channel.
         */
        const inlinePatternArray = _.filter(
          this.patternsArray,
          (x) => x.channelIndex === this.displayedChannelsArr[i],
        );
        if (inlinePatternArray.length > 0) {
          // *: Have pattern
          for (let t = 0; t < inlinePatternArray.length; t += 1) {
            startEndArray.push({
              start: inlinePatternArray[t].startSample,
              end: inlinePatternArray[t].endSample,
            });
            const arrayPattern = [];
            for (let o = startSample; o <= endSample; o += 1) {
              if (o >= inlinePatternArray[t].startSample && o <= inlinePatternArray[t].endSample) {
                arrayPattern.push(
                  new fabric.Point(
                    this.pixelSamples[i][o].x - this.pixelSamples[i][startSample].x,
                    this.pixelSamples[i][o].y,
                  ),
                );
              }
            }
            if (arrayPattern.length > 0) {
              arrayPatternPoints.push({
                points: arrayPattern,
                strokeStyle: inlinePatternArray[t].color,
              });
            }
          }
        }

        /**
         * AFib events belonging to the channel drawn at the current row index. Filters the stored AFib event array by a channel index equal to the displayed channel at position i.
         *
         * @returns AFib events for that channel.
         */
        const inlineAFibEventArray = _.filter(
          this.afibEventsArray,
          (x) => x.channelIndex === this.displayedChannelsArr[i],
        );
        if (inlineAFibEventArray.length > 0) {
          // *: Have AFib event
          for (let t = 0; t < inlineAFibEventArray.length; t += 1) {
            startEndArray.push({
              start: inlineAFibEventArray[t].startSample,
              end: inlineAFibEventArray[t].endSample,
            });
            const arrayAFibEvent = [];
            for (let o = startSample; o <= endSample; o += 1) {
              if (
                o >= inlineAFibEventArray[t].startSample &&
                o <= inlineAFibEventArray[t].endSample
              ) {
                arrayAFibEvent.push(
                  new fabric.Point(
                    this.pixelSamples[i][o].x - this.pixelSamples[i][startSample].x,
                    this.pixelSamples[i][o].y,
                  ),
                );
              }
            }
            if (arrayAFibEvent.length > 0) {
              arrayAFibEventPoints.push({
                points: arrayAFibEvent,
                strokeStyle: inlineAFibEventArray[t].color,
              });
            }
          }
        }

        // *: Other line between sample marks
        const otherFirstLine = [];
        const otherLastLine = [];
        const otherLine = [];
        startEndArray = _.orderBy(startEndArray, ['start'], ['asc']);
        for (let m = 0; m < startEndArray.length; m += 1) {
          if (m === 0) {
            if (startEndArray[m].start > startSample) {
              for (let n = startSample; n <= startEndArray[m].start; n += 1) {
                otherFirstLine.push(
                  new fabric.Point(
                    this.pixelSamples[i][n].x - this.pixelSamples[i][startSample].x,
                    this.pixelSamples[i][n].y,
                  ),
                );
              }
            }
          }

          if (m === startEndArray.length - 1) {
            if (startEndArray[m].end < endSample) {
              for (let g = startEndArray[m].end; g <= endSample; g += 1) {
                otherLastLine.push(
                  new fabric.Point(
                    this.pixelSamples[i][g].x - this.pixelSamples[i][startSample].x,
                    this.pixelSamples[i][g].y,
                  ),
                );
              }
            }
          }

          if (m !== startEndArray.length - 1) {
            const array = [];
            for (let h = startEndArray[m].end; h <= startEndArray[m + 1].start; h += 1) {
              array.push(
                new fabric.Point(
                  this.pixelSamples[i][h].x - this.pixelSamples[i][startSample].x,
                  this.pixelSamples[i][h].y,
                ),
              );
            }
            if (array.length > 0) {
              otherLine.push(array);
            }
          }
        }

        if (otherFirstLine.length > 0) {
          arrayLinePointsBlack.push({ points: otherFirstLine, strokeStyle: '#000' });
        }
        if (otherLastLine.length > 0) {
          arrayLinePointsBlack.push({ points: otherLastLine, strokeStyle: '#000' });
        }
        _.forEach(otherLine, (element) => {
          arrayLinePointsBlack.push({ points: element, strokeStyle: '#000' });
        });
      } else {
        // *: Not have sample mark
        // *: Check to have pattern or not
        /**
         * Patterns belonging to the channel drawn at the current row index. Filters the stored pattern array by a channel index equal to the displayed channel at position i.
         *
         * @returns Patterns for that channel.
         */
        const inlinePatternArray = _.filter(
          this.patternsArray,
          (x) => x.channelIndex === this.displayedChannelsArr[i],
        );

        // *: Check to have AFib event or not
        /**
         * AFib events belonging to the channel drawn at the current row index. Filters the stored AFib event array by a channel index equal to the displayed channel at position i.
         *
         * @returns AFib events for that channel.
         */
        const inlineAFibEventArray = _.filter(
          this.afibEventsArray,
          (x) => x.channelIndex === this.displayedChannelsArr[i],
        );

        if (inlinePatternArray.length > 0 || inlineAFibEventArray.length > 0) {
          let startEndArray = [];
          for (let t = 0; t < inlinePatternArray.length; t += 1) {
            startEndArray.push({
              start: inlinePatternArray[t].startSample,
              end: inlinePatternArray[t].endSample,
            });
            const arrayPattern = [];
            for (let o = startSample; o <= endSample; o += 1) {
              if (o >= inlinePatternArray[t].startSample && o <= inlinePatternArray[t].endSample) {
                arrayPattern.push(
                  new fabric.Point(
                    this.pixelSamples[i][o].x - this.pixelSamples[i][startSample].x,
                    this.pixelSamples[i][o].y,
                  ),
                );
              }
            }
            if (arrayPattern.length > 0) {
              arrayPatternPoints.push({
                points: arrayPattern,
                strokeStyle: inlinePatternArray[t].color,
              });
            }
          }

          for (let t = 0; t < inlineAFibEventArray.length; t += 1) {
            startEndArray.push({
              start: inlineAFibEventArray[t].startSample,
              end: inlineAFibEventArray[t].endSample,
            });
            const arrayAFibEvent = [];
            for (let o = startSample; o <= endSample; o += 1) {
              if (
                o >= inlineAFibEventArray[t].startSample &&
                o <= inlineAFibEventArray[t].endSample
              ) {
                arrayAFibEvent.push(
                  new fabric.Point(
                    this.pixelSamples[i][o].x - this.pixelSamples[i][startSample].x,
                    this.pixelSamples[i][o].y,
                  ),
                );
              }
            }
            if (arrayAFibEvent.length > 0) {
              arrayAFibEventPoints.push({
                points: arrayAFibEvent,
                strokeStyle: inlineAFibEventArray[t].color,
              });
            }
          }

          // *: Other line between patterns
          startEndArray = _.orderBy(startEndArray, ['start'], ['asc']);

          if (startEndArray.length === 1) {
            const otherFirstLine = [];
            const otherLastLine = [];
            for (let n = startSample; n <= startEndArray[0].start; n += 1) {
              otherFirstLine.push(
                new fabric.Point(
                  this.pixelSamples[i][n].x - this.pixelSamples[i][startSample].x,
                  this.pixelSamples[i][n].y,
                ),
              );
            }

            for (let g = startEndArray[0].end; g <= endSample; g += 1) {
              otherLastLine.push(
                new fabric.Point(
                  this.pixelSamples[i][g].x - this.pixelSamples[i][startSample].x,
                  this.pixelSamples[i][g].y,
                ),
              );
            }

            if (otherFirstLine.length > 0) {
              arrayLinePointsBlack.push({ points: otherFirstLine, strokeStyle: '#000' });
            }
            if (otherLastLine.length > 0) {
              arrayLinePointsBlack.push({ points: otherLastLine, strokeStyle: '#000' });
            }
          } else {
            const otherFirstLine = [];
            const otherLastLine = [];
            const otherLine = [];

            for (let m = 0; m < startEndArray.length; m += 1) {
              if (m === 0) {
                if (startEndArray[m].start > startSample) {
                  for (let n = startSample; n <= startEndArray[m].start; n += 1) {
                    otherFirstLine.push(
                      new fabric.Point(
                        this.pixelSamples[i][n].x - this.pixelSamples[i][startSample].x,
                        this.pixelSamples[i][n].y,
                      ),
                    );
                  }
                }
              }

              if (m === startEndArray.length - 1) {
                if (startEndArray[m].end < endSample) {
                  for (let g = startEndArray[m].end; g <= endSample; g += 1) {
                    otherLastLine.push(
                      new fabric.Point(
                        this.pixelSamples[i][g].x - this.pixelSamples[i][startSample].x,
                        this.pixelSamples[i][g].y,
                      ),
                    );
                  }
                }
              }

              if (m !== startEndArray.length - 1) {
                const array = [];
                for (let h = startEndArray[m].end; h <= startEndArray[m + 1].start; h += 1) {
                  array.push(
                    new fabric.Point(
                      this.pixelSamples[i][h].x - this.pixelSamples[i][startSample].x,
                      this.pixelSamples[i][h].y,
                    ),
                  );
                }

                if (array.length > 0) {
                  otherLine.push(array);
                }
              }
            }

            if (otherFirstLine.length > 0) {
              arrayLinePointsBlack.push({ points: otherFirstLine, strokeStyle: '#000' });
            }
            if (otherLastLine.length > 0) {
              arrayLinePointsBlack.push({ points: otherLastLine, strokeStyle: '#000' });
            }
            _.forEach(otherLine, (element) => {
              arrayLinePointsBlack.push({ points: element, strokeStyle: '#000' });
            });
          }
        } else {
          const arrayLine = [];
          for (let l = startSample; l <= endSample; l += 1) {
            arrayLine.push(
              new fabric.Point(
                this.pixelSamples[i][l].x - this.pixelSamples[i][startSample].x,
                this.pixelSamples[i][l].y,
              ),
            );
          }
          if (arrayLine.length > 0) {
            arrayLinePointsBlack.push({ points: arrayLine, strokeStyle: '#000' });
          }
        }
      }
    }

    // *: Create chart svg path
    const pathChart: any = [];
    _.forEach(arrayLinePointsBlack, (element) => {
      const { points, strokeStyle } = element;
      if (points.length > 0) {
        const pl = this.drawPolyline(points, strokeStyle, this.lineWidthExport);
        this.canvasChart.add(pl);
        pathChart.push(pl);
      }
    });

    _.forEach(arrayLinePointsBlue, (element) => {
      const { points, strokeStyle } = element;
      if (points.length > 0) {
        const pl = this.drawPolyline(points, strokeStyle, this.lineWidthExport);
        this.canvasChart.add(pl);
        pathChart.push(pl);
      }
    });

    _.forEach(arrayPatternPoints, (element) => {
      const { points, strokeStyle } = element;
      if (points.length > 0) {
        const pl = this.drawPolyline(points, strokeStyle, this.lineWidthExport);
        this.canvasChart.add(pl);
        pathChart.push(pl);
      }
    });

    _.forEach(arrayAFibEventPoints, (element) => {
      const { points, strokeStyle } = element;
      if (points.length > 0) {
        const pl = this.drawPolyline(points, strokeStyle, this.lineWidthExport);
        this.canvasChart.add(pl);
        pathChart.push(pl);
      }
    });

    // *: Export svg chart
    const svg = this.canvasChart.toSVG(
      {
        viewBox: {
          x: 0,
          y: 0,
          width: 946,
          height: 250,
        },
      },
      (e: any) => (e.includes('hidden') ? '' : e),
    );

    // *: Remove line
    _.forEach(pathChart, (element) => {
      this.canvasChart.remove(element);
    });

    return svg;
  };

  EcgView.prototype.importMark = function (offsetX: any, specifyMark: any) {
    if (specifyMark.type === ANNOTATION_TYPE.SAMPLE_MARK) {
      const sampleMark = new SampleMark.SampleMark(
        this.canvasChart,
        this.verticalChannelPlacement,
        this.config,
        this.displayedChannelsArr,
        this.pixelSamples,
        specifyMark,
      );
      (sampleMark as any).drawOneSampleMark(offsetX, 'blue');
      this.sampleMarksArray.push(sampleMark);
    } else if (specifyMark.type === ANNOTATION_TYPE.PATTERN) {
      const pattern = new Pattern.Pattern(
        this.canvasChart,
        this.config,
        this.displayedChannelsArr,
        this.pixelSamples,
        specifyMark,
      );
      pattern.color = specifyMark.color;
      (pattern as any).drawOnePattern(offsetX, pattern.color);
      this.patternsArray.push(pattern);
    } else if (this.isAppliedAI) {
      const afibEvent = new AFibEvent.AFibEvent(
        this.canvasChart,
        this.config,
        this.displayedChannelsArr,
        this.pixelSamples,
        specifyMark,
      );
      (afibEvent as any).drawOneAFibEvent(offsetX);
      this.afibEventsArray.push(afibEvent);
    }
  };

  EcgView.prototype.getJSONObject = function (): any {
    const objArr: any = [];
    _.forEach(this.sampleMarksArray, (sampleMark) => {
      objArr.push(sampleMark.getJSONObject());
    });
    _.forEach(this.patternsArray, (pattern) => {
      objArr.push(pattern.getJSONObject());
    });
    if (this.isAppliedAI) {
      _.forEach(this.afibEventsArray, (afibEvent) => {
        objArr.push(afibEvent.getJSONObject());
      });
    }
    return objArr;
  };
})();

export { EcgView };
export default { EcgView };
